import { render, staticRenderFns } from "./Planning.vue?vue&type=template&id=f87bd0fa&scoped=true"
import script from "./Planning.vue?vue&type=script&lang=js"
export * from "./Planning.vue?vue&type=script&lang=js"
import style0 from "./Planning.vue?vue&type=style&index=0&id=f87bd0fa&prod&lang=scss"
import style1 from "./Planning.vue?vue&type=style&index=1&id=f87bd0fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87bd0fa",
  null
  
)

export default component.exports